// extracted by mini-css-extract-plugin
module.exports = {"root":"root--Rdc+n","list":"list--pdcSk"};